import { useMutation, useQueryClient } from '@tanstack/react-query'
import { MasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { handleHTTPError } from 'src/state/middleware/saga/handleHttpError'
import { queryKeys as mastersQueryKeys } from '../../api/queryKeys'
import { queryKeys } from './queryKeys'

type UpdateMasterFieldDefNameParams = {
  fieldDefCode: string
  name: string
}

export const useMutationUpdateMasterFieldDefName = (masterUuid: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({
      fieldDefCode,
      name,
    }: UpdateMasterFieldDefNameParams) => {
      return await baseClient
        .getApi(MasterApi)
        .updateMasterFieldDefName({
          masterUuid,
          fieldDefCode,
          patchMasterFieldDefRequest: { name },
        })
        .catch(handleHTTPError)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.masterFieldDefs(masterUuid),
      })
      queryClient.invalidateQueries({
        queryKey: mastersQueryKeys.master(masterUuid),
      })
      queryClient.invalidateQueries({
        queryKey: mastersQueryKeys.products,
      })
    },
  })
}
